import moment from "moment";

const NOTIFICATION_DATE_PARSE_FORMATS = [
  moment.ISO_8601,
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss.SSSZ",
  "YYYY-MM-DD",
  "DD-MM-YYYY",
  "DD/MM/YYYY",
  "DD/MM/YYYY HH:mm:ss",
  "D MMM YYYY",
  "MMM D, YYYY",
];

const isTimeOnlyString = (value) =>
  /^\d{1,2}:\d{2}(:\d{2})?$/.test(String(value ?? "").trim());

const parseNotificationMoment = (value) => {
  if (value === undefined || value === null || value === "") return null;

  if (typeof value === "number" || /^\d{10,13}$/.test(String(value).trim())) {
    const num = Number(value);
    const fromEpoch = moment(num > 9999999999 ? num : num * 1000);
    if (fromEpoch.isValid()) return fromEpoch;
  }

  const raw = String(value).trim();
  if (!raw || isTimeOnlyString(raw)) return null;

  let parsed = moment(raw, NOTIFICATION_DATE_PARSE_FORMATS, true);
  if (!parsed.isValid()) {
    parsed = moment(raw);
  }
  return parsed.isValid() ? parsed : null;
};

/** Display like mobile app: "28 Apr" */
export const formatNotificationDisplayDate = (notification) => {
  if (!notification || typeof notification !== "object") return "";

  const createdAt =
    notification.created_at ??
    notification.createdAt ??
    notification.created_date ??
    notification.datetime ??
    notification.updated_at ??
    notification.added_on ??
    notification.notify_date ??
    notification.notification_date ??
    notification.notificationDate;

  const dateOnly =
    notification.date ?? notification.notification_day ?? notification.day;

  const timeOnly = notification.time ?? notification.notification_time;

  let parsed = parseNotificationMoment(createdAt);

  if (!parsed && dateOnly) {
    if (timeOnly && isTimeOnlyString(timeOnly)) {
      parsed = parseNotificationMoment(`${dateOnly} ${timeOnly}`);
    } else {
      parsed = parseNotificationMoment(dateOnly);
    }
  }

  if (!parsed && timeOnly && !isTimeOnlyString(timeOnly)) {
    parsed = parseNotificationMoment(timeOnly);
  }

  if (!parsed) return "";

  return parsed.format("D MMM");
};
